var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 64H56C49.625 64 43.5 66.5 39 71S32 81.625 32 88V352C32 405 75 448 128 448H320C373 448 416 405 416 352V288H464C525.75 288 576 237.75 576 176S525.75 64 464 64ZM400 352C400 396.111 364.111 432 320 432H128C83.889 432 48 396.111 48 352V88C48 82.871 52.172 80 56 80H400V352ZM464 272H416V80H464C516.938 80 560 123.062 560 176S516.938 272 464 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMug);
export default __webpack_public_path__ + "static/media/mug.6960f099809f640b3c12bada5b673a50.svg";
export { ForwardRef as ReactComponent };